
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SmartAlertDetail {
  cbr_id: number;
  style_code: string;
  style_name: string;
  buyer: string;
  merchant: string;
  plan_end_date: string | null;
  remark: string;
}

export interface SmartAlertGroup {
  activity_id: number;
  activity_name: string;
  message: string;
  count: number;
  details: SmartAlertDetail[];
}

export interface SmartAlertResponse {
  show_popup: boolean;
  is_viewed: boolean;
  alert_date: string;
  total_count: number;
  overall_remark: string;
  smart_alerts: SmartAlertGroup[];
}

export interface SmartAlertSavePayload {
  action: 'save' | 'dismiss';
  overall_remark?: string;
  activity_remarks?: {
    activity_id: number;
    cbr_id: number;
    remark: string;
  }[];
}

@Injectable({
  providedIn: 'root'
})
export class SmartAlertService {
  private http = inject(HttpClient);

  // Change this path to match your environment API configuration.
  private readonly baseUrl =
    `${environment.apiUrl}/api/smart-alerts/`;

  getAlerts(): Observable<SmartAlertResponse> {
    return this.http.get<SmartAlertResponse>(this.baseUrl);
  }

  saveAlerts(
    payload: SmartAlertSavePayload
  ): Observable<{ success: boolean; message: string }> {
    return this.http.post<{ success: boolean; message: string }>(
      `${this.baseUrl}save/`,
      payload
    );
  }
}
